

import axios, { AxiosResponse } from "axios";
import TitleValue from "../../models/dtos/base/TitleValue";
import BaseService from "../base/BaseService";

export default class StaticContentService extends BaseService {
    getCompanyInformation(): Promise<TitleValue<string>> {
        return axios.get( `/StudentAppConfig/CompanyInformation`)
            .then(function (response: AxiosResponse<TitleValue<string>>) {
                return response.data;
            });
    }

    getAssistantDetail(): Promise<TitleValue<string>> {
        return axios.get( `/StudentAppConfig/AssistantDetail`)
            .then(function (response: AxiosResponse<TitleValue<string>>) {
                return response.data;
            });
    }
}